import React from 'react';
import './RawText.scss';

export const RawText = ({ node }) => (
    <div
        className="raw-text"
        dangerouslySetInnerHTML={{ __html: node?.field_content_text?.value }}
    ></div>
);
